export default __webpack_public_path__ + "static/media/cargills_GO.045a0cfd.png";